var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Promise from 'bluebird';
import { TaxonomyHelper } from './TaxonomyHelper';
import { CacheLayer } from '@/central';
import { BaseService } from './BaseService';
var PageService = (function (_super) {
    __extends(PageService, _super);
    function PageService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PageService.prototype, "viewFields", {
        get: function () {
            return [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageService.prototype, "fieldTitle", {
        get: function () {
            return 'Title';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageService.prototype, "fieldTeaser", {
        get: function () {
            return 'anrisstext';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageService.prototype, "fieldDate", {
        get: function () {
            return 'Created';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageService.prototype, "fieldEditDate", {
        get: function () {
            return 'Modified';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageService.prototype, "fieldCategory", {
        get: function () {
            return 'RUBKategorien';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageService.prototype, "urlWeb", {
        get: function () {
            return 'Begriffesammlung';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageService.prototype, "urlList", {
        get: function () {
            return 'seiten';
        },
        enumerable: true,
        configurable: true
    });
    PageService.prototype.finalizeItem = function (item, spItem, categoryField, list, web, site) {
        var categories = TaxonomyHelper.getTermFieldValues(spItem.get_item(this.fieldCategory));
        item.tags = {};
        var updateDays = 1000 * 60 * 60 * 24 * 5;
        if (new Date(item.date) > new Date(new Date().getTime() - updateDays)) {
            item.tags['neu'] = '#8DAE10';
        }
        if ((new Date(item.editDate) > new Date(new Date().getTime() - updateDays)) && (Object.keys(item.tags).length === 0 && item.tags.constructor === Object)) {
            item.tags['Update'] = '#8DAE10';
        }
        if (categories.findIndex(function (c) { return c.get_label() == PageService.coronaTag; }) > -1) {
            item.tags = { Corona: '#EC7405' };
        }
        return Promise.resolve(item);
    };
    PageService.prototype.finalizeItems = function (items, list, web, site) {
        return Promise.resolve(items);
    };
    PageService.prototype.loadPages = function (categoryGuid, sort, rowLimit) {
        var _this = this;
        if (rowLimit === void 0) { rowLimit = 100; }
        return CacheLayer.simpleLoad(function () {
            return _this.loadItems(categoryGuid, sort, rowLimit);
        }, "loadPages-" + categoryGuid + "-" + sort + "-" + rowLimit);
    };
    PageService.coronaTag = 'Corona Pandemie';
    return PageService;
}(BaseService));
export { PageService };
